import type { MerchantApiClient } from "../../types.js";
import { createFeedbackApi, type FeedbackApi } from "./api.js";
export function createFeedbackService(client: MerchantApiClient): FeedbackApi {
  return createFeedbackApi(client);
}
